import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["box"]

  connect() {
    this._onOver = (e) => {
      const group = e.target.closest("g[data-tip]")

      if (this._hoveredGroup && group !== this._hoveredGroup) {
        this._restoreGroup(this._hoveredGroup)
      }

      if (!group) {
        if (this._hoveredGroup) {
          this._restoreGroup(this._hoveredGroup)
          this._hoveredGroup = null
        }
        this.boxTarget.classList.add("hidden")
        return
      }

      if (group === this._hoveredGroup) return

      this._hoveredGroup = group
      const circle = group.querySelector("circle")
      const text = group.querySelector("text")

      if (!group.dataset.origR) {
        group.dataset.origR = circle?.getAttribute("r") || "10"
        group.dataset.origStroke = circle?.getAttribute("stroke-width") || "1.5"
        group.dataset.origFontSize = text?.getAttribute("font-size") || "9"
      }

      if (circle) {
        circle.setAttribute("r", parseInt(group.dataset.origR) + 3)
        circle.setAttribute("stroke-width", (parseFloat(group.dataset.origStroke) || 1.5) + 0.5)
      }
      if (text) {
        text.setAttribute("font-size", (parseInt(group.dataset.origFontSize) || 9) + 2)
      }

      const parent = group.parentNode
      if (parent) parent.appendChild(group)

      this.boxTarget.textContent = group.getAttribute("data-tip")
      this.boxTarget.classList.remove("hidden")
    }

    this._onLeave = () => {
      if (this._hoveredGroup) {
        this._restoreGroup(this._hoveredGroup)
        this._hoveredGroup = null
      }
      this.boxTarget.classList.add("hidden")
    }

    this._onMove = (e) => {
      if (this.boxTarget.classList.contains("hidden")) return
      this.boxTarget.style.left = (e.clientX + 14) + "px"
      this.boxTarget.style.top = (e.clientY - 10) + "px"
    }

    this.element.addEventListener("mouseover", this._onOver)
    this.element.addEventListener("mouseleave", this._onLeave)
    this.element.addEventListener("mousemove", this._onMove)
  }

  disconnect() {
    this.element.removeEventListener("mouseover", this._onOver)
    this.element.removeEventListener("mouseleave", this._onLeave)
    this.element.removeEventListener("mousemove", this._onMove)
  }

  _restoreGroup(group) {
    const circle = group.querySelector("circle")
    const text = group.querySelector("text")
    if (circle && group.dataset.origR) {
      circle.setAttribute("r", group.dataset.origR)
      circle.setAttribute("stroke-width", group.dataset.origStroke)
    }
    if (text && group.dataset.origFontSize) {
      text.setAttribute("font-size", group.dataset.origFontSize)
    }
  }
}
